'use strict';

function getOwnerWindow(node) {
    return node instanceof Element ? getOwnerDocument(node)?.defaultView ?? window : window;
}
function getOwnerDocument(node) {
    return node instanceof Element ? node.ownerDocument ?? document : document;
}
function dom() {
    return !!(typeof window !== 'undefined' && window.document?.createElement);
}
const isBrowser = dom();

exports.dom = dom;
exports.getOwnerDocument = getOwnerDocument;
exports.getOwnerWindow = getOwnerWindow;
exports.isBrowser = isBrowser;
//# sourceMappingURL=dom.js.map
